import React from "react";
import InputTags from "@semcore/input-tags";
import Ellipsis from "@semcore/ellipsis";
import { Flex } from "@semcore/flex-box";

const AddKeywordTag = ({
  item,
  setItem,
  handleInputAddKeyword,
  placeholder,
}) => {
  const inputValueRef = React.useRef(null);
  const [value, setValue] = React.useState("");

  const handleAppendTags = (newTags) => {
    const newTagsArr = newTags?.flatMap((item) =>
      item
        .split(/[\r\n,]+/)
        .map((word) => word.trim())
        .filter(Boolean)
    );
    handleInputAddKeyword(newTagsArr);
    setValue("");
  };

  const handleRemoveTag = () => {
    if (item.length === 0) return;
    setItem(item.slice(0, -1));
    setValue(`${item.slice(-1)[0]} ${value}`);
  };

  const handleCloseTag = (e) => {
    e.preventDefault();
  };

  const handleTagKeyDown = (e) => {
    if (e.code === "Enter" || e.code === "Space") {
      handleEditTag(e);
    }
    return false;
  };

  const handleEditTag = (e) => {
    const { dataset } = e.currentTarget;
    let allTags = [...item];
    if (value) {
      allTags = [...allTags, value];
    }
    setItem(allTags.filter((tag, ind) => ind !== Number(dataset.id)));
    if (!e.defaultPrevented && dataset.id !== undefined) {
      setValue(item[Number(dataset.id)]);
      inputValueRef.current?.focus();
    }
    return false;
  };

  const handleInputKeyDown = (e) => {
    const value = e.target.value || null;
    if (e.key === "Enter" && value) {
      handleAppendTags([value]);
      return false;
    }
  };

  return (
    <Flex direction="column">
      <InputTags
        mt={2}
        size="l"
        onAppend={handleAppendTags}
        onRemove={handleRemoveTag}
        hMax={"200px"}
      >
        {item.map((tag, idx) => (
          <InputTags.Tag
            key={idx}
            tag={InputTags.Tag}
            theme="primary"
            editable
            data-id={idx}
            onClick={handleEditTag}
            onKeyDown={handleTagKeyDown}
            active={false}
          >
            <InputTags.Tag.Text>
              <Ellipsis wMax={100}>{tag}</Ellipsis>
            </InputTags.Tag.Text>
            <InputTags.Tag.Close onClick={handleCloseTag} />
          </InputTags.Tag>
        ))}
        <InputTags.Value
          value={value}
          onChange={setValue}
          onKeyDown={handleInputKeyDown}
          ref={inputValueRef}
          id="add-keyword"
          placeholder={placeholder || "Type Prompts and Press Return/Enter Key"}
          autoComplete="off"
        />
      </InputTags>
    </Flex>
  );
};

export default AddKeywordTag;
